import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTAButton({ to, href, children, primary, testId, className = "" }) {
  const cls = `inline-flex items-center justify-center gap-2 px-6 py-3.5 text-[12px] font-mono-alt tracking-[0.18em] uppercase hover-lift ${
    primary
      ? "bg-white text-[#0A0B0E] hover:bg-white/90"
      : "border border-white/25 text-white hover:border-white/60 hover:bg-white/[0.03]"
  } ${className}`;
  const inner = (<>{children}<ArrowRight className="w-3.5 h-3.5" strokeWidth={2.5} /></>);
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testId} className={cls}>{inner}</a>;
  }
  return <Link to={to} data-testid={testId} className={cls}>{inner}</Link>;
}
